const BASKET = "basket/";

export const UPDATE_SELECT_SEATS = BASKET + "updateSelectSeats";
export const UPDATE_BASKET_LENGTH = BASKET + "updateBasketLength";